import {Injectable, Inject} from 'ng-metadata/core';
import {ChangeLangService} from "../../infra/lang/changeLang.service";
import {MediaQueries} from "../../infra/mediaQueries.service";
import {isBrowserChrome, isBrowserIE} from '../../infra/browserSniffer';

@Injectable()
export class ScrollService {
    constructor(@Inject('$interval') private $interval: ng.IIntervalService,
                private changeLangService: ChangeLangService,
                private mediaQueries: MediaQueries){}



    public  easeInOutQuart(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t * t + b;
        t -= 2;
        return -c / 2 * (t * t * t * t - 2) + b;
    };


    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }



    public smoothScrollClick(direction: String, elem,featuredElem = null) {
        let clickScrollDistance:number = 0;
        if(featuredElem != null){
            let numOfItem:number = this.detectMobile()? 1 : 2;
            let itemWidth = featuredElem[0].clientWidth + 15;
            clickScrollDistance = itemWidth *numOfItem ;

        }
        else{
            clickScrollDistance = 120;
        }
        if (direction === 'left') {
            clickScrollDistance = -clickScrollDistance;
        }

        let frame = 0;
        let numOfFrames = 60;
        let beginningPos = elem.scrollLeft;

        let interval = this.$interval(() => {
            let newPos = this.easeInOutQuart(frame, beginningPos, clickScrollDistance, numOfFrames);
            frame++;
            elem.scrollLeft = newPos;
            if (frame === numOfFrames) {
                this.$interval.cancel(interval);
            }
        }, 2);
    }



    public onLeftArrowClick(elem) {
        if(elem == null){
            return;
        }
        this.smoothScrollClick('left', elem);
    }

    public onRightArrowClick(elem) {
        if(elem == null){
            return;
        }
        this.smoothScrollClick('right', elem);
    }

    public isShowLeftArrow(elem) {
        if(elem == null){
            return;
        }
        if (this.changeLangService.direction === 'rtl'){
            if (!isBrowserChrome() || !isBrowserIE()){
                return elem.scrollLeft > elem.offsetWidth - elem.scrollWidth;
            }
        }
        return elem.scrollLeft > 0;
    };

    public isShowRightArrow(elem: HTMLElement) {
        if(elem == null){
            return;
        }
        return this.getScrollRight(elem) > 0;
    };

    private getScrollRight(elem: HTMLElement) {
        if(elem == null){
            return;
        }
        let scrollRight = elem.scrollWidth - elem.scrollLeft - elem.offsetWidth;
        if (this.changeLangService.direction === 'rtl'){
            if (!isBrowserChrome() || !isBrowserIE()){
                return (elem.scrollLeft == 0) ? 0 : scrollRight;
            }
        }
        return (scrollRight < 15) ? 0 : scrollRight;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/scroller/scroll.service.ts